// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"11bd160b","315":"c765035e","697":"65a257d1"}[chunkId] + ".css";
};